import { AppDataState } from './app-data-store';
import { EventInventoryAssociation } from './interface/event-inventory-details';

export const SET_EVENT_INVETORY_DETAILS = 'SET_EVENT_INVETORY_DETAILS';

export type SetEventInvetoryDetailsAction = {
  type: typeof SET_EVENT_INVETORY_DETAILS;
  payload: EventInventoryAssociation[];
};

// redux update store action
export const setEventInvetoryDetailsAction = (
  payload: EventInventoryAssociation[]
): SetEventInvetoryDetailsAction => {
  return {
    type: SET_EVENT_INVETORY_DETAILS,
    payload,
  };
};

// redux reducer handler - state updater
export const setEventInvetoryDetailsHandler = (
  state: AppDataState,
  action: SetEventInvetoryDetailsAction
): AppDataState => {
  return {
    ...state,
    eventInventoryAssociation: action.payload,
  };
};
